import { Component } from 'react'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import {
    Accordion, AccordionDetails, AccordionSummary, Box, Button, Checkbox, FormControlLabel,
    MenuItem, Select, TextField, Typography, RadioGroup, Radio
} from '@mui/material'
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { DOC_PRINT_DEFAULT, OTHER_INVESTIGATION_CONFIG_DATA } from '../../../../Utility/Constants'
import { localGetItem, localSetItem } from '../../../../Utility/Services/CacheProviderService'

const SEARCH_DRUG_NAME = [
    { label: 'Brand Name', value: 1 },
    { label: 'Generic Name', value: 2 },
    { label: 'Both', value: 3 },
]

const PRESCRIPTION_LANGUAGE = [
    { label: 'English', value: 'English' },
    { label: 'Tamil', value: 'Tamil' },
    { label: 'Hindi', value: 'Hindi' },
]

export default class DocNotesConfig extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isOPT: false,
            lockPeriod: '30',
            transmitSms: null,
            summarySms: null,
            doctorPrintList: {},
            loginInfo: '{}',
            dupDocPrintList: '{}',
            auto_fetch_prescription_drug: false,
            drug_search: 1,
            doctorStatus: [],
            app_landing_sts: 'All',
            printOrder: null,
            specialization: "",
            other_investigation_config: OTHER_INVESTIGATION_CONFIG_DATA,
            dragItemIndex: null,
            complaints_common_textbox: false,
            include_suggestion_in_treat_plan: false,
            show_review_plan_time: true,
            show_allergy_suggestion:false,
            prescription_save_transmit: false,
            show_tablet_unit_in_print: false,
            show_address_field_prescription_print: false,
            sort_home_token_by: "default",
            prescription_language: 'English',
        }
    }

    componentDidMount() {
        let loginInfo = localGetItem("loggedInUserInfo")
        let loginData = JSON.parse(loginInfo)
        let specialization = loginData.specialization_name
        this.setState({ loginInfo: loginData, specialization: specialization }, () => {
            // this.setState({ doctorStatus: this.state.loginInfo?.service_type === 'OPT' ? OPT_DOCTOR_STATUS : DOCTOR_STATUS })
            this.getDoctorNotesConfigList()
        })

    }

    getDoctorNotesConfigList = () => {
        try {
            let clinic_id = JSON.parse(localGetItem('SelectedDoctorClinicId'))
            RestAPIService.getAllTwo(Serviceurls.DOC_OPT_CONFIG)
                .then((response) => {
                    if (response.data.status === 'success') {
                        let Doctor_Print_Layout = JSON.parse(JSON.stringify(DOC_PRINT_DEFAULT))
                        if (this.state.loginInfo?.service_type === "ENT") {
                            let ENTLayout = { is_checked: true, label: 'Clinical Examination', value: 'ClinicExaminationImage', print_order: Doctor_Print_Layout.other_doctor?.length }
                            Doctor_Print_Layout.other_doctor?.push(ENTLayout)
                        }
                        if (this.state.loginInfo?.service_type === "OBGYN") {
                            Doctor_Print_Layout.other_doctor?.push({ is_checked: true, label: 'Obstetric Data', value: 'ObstetricData', print_order: Doctor_Print_Layout.other_doctor?.length })
                        }
                        if (this.state.specialization === "OBSTETRICS & GYNECOLOGY") {
                            let OBGYNPrintorder = [
                                { is_checked: false, label: 'Ovulation', value: 'Ovulation', print_order: Doctor_Print_Layout.other_doctor?.length, isAdvance: true },
                                { is_checked: false, label: 'Antenatal', value: 'Antenatal', print_order: Doctor_Print_Layout.other_doctor?.length + 1, isAdvance: true },
                                { is_checked: false, label: 'Medication History', value: 'MedicalHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 2, isAdvance: true },
                                { is_checked: false, label: 'Hospitalization History', value: 'HospitalizationHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 3, isAdvance: true },
                                { is_checked: false, label: 'Social History', value: 'SocialHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 4, isAdvance: true },
                                { is_checked: false, label: 'Family History', value: 'FamilyHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 5, isAdvance: true },
                                { is_checked: false, label: 'OBGYN History', value: 'OBGYNHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 6, isAdvance: true },
                            ]
                            Doctor_Print_Layout.other_doctor = [...Doctor_Print_Layout.other_doctor, ...OBGYNPrintorder];
                        } else if (this.state.specialization === 'PEDIATRICIAN') {
                            let OBGYNPrintorder = [
                                { is_checked: false, label: 'Medication History', value: 'MedicalHistory', print_order: Doctor_Print_Layout.other_doctor?.length, isAdvance: true },
                                { is_checked: false, label: 'Hospitalization History', value: 'HospitalizationHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 1, isAdvance: true },
                                { is_checked: false, label: 'Social History', value: 'SocialHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 2, isAdvance: true },
                                { is_checked: false, label: 'Family History', value: 'FamilyHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 3, isAdvance: true },
                                { is_checked: false, label: 'PD History', value: 'PDHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 4, isAdvance: true },
                            ]
                            Doctor_Print_Layout.other_doctor = [...Doctor_Print_Layout.other_doctor, ...OBGYNPrintorder];
                        } else if (this.state.specialization === 'DIABETOLOGY') {
                            let OBGYNPrintorder = [
                                { is_checked: false, label: 'Medication History', value: 'MedicalHistory', print_order: Doctor_Print_Layout.other_doctor?.length, isAdvance: true },
                                { is_checked: false, label: 'Hospitalization History', value: 'HospitalizationHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 1, isAdvance: true },
                                { is_checked: false, label: 'Social History', value: 'SocialHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 2, isAdvance: true },
                                { is_checked: false, label: 'Family History', value: 'FamilyHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 3, isAdvance: true },
                                { is_checked: false, label: 'Diabetic History', value: 'DiabeticHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 4, isAdvance: true },
                            ]
                            Doctor_Print_Layout.other_doctor = [...Doctor_Print_Layout.other_doctor, ...OBGYNPrintorder];
                        } else if (this.state.specialization === 'OPHTHALMOLOGY') {
                            let OBGYNPrintorder = [
                                { is_checked: false, label: 'Medication History', value: 'MedicalHistory', print_order: Doctor_Print_Layout.opt_doctor?.length, isAdvance: true },
                                { is_checked: false, label: 'Hospitalization History', value: 'HospitalizationHistory', print_order: Doctor_Print_Layout.opt_doctor?.length + 1, isAdvance: true },
                                { is_checked: false, label: 'Social History', value: 'SocialHistory', print_order: Doctor_Print_Layout.opt_doctor?.length + 2, isAdvance: true },
                                { is_checked: false, label: 'Family History', value: 'FamilyHistory', print_order: Doctor_Print_Layout.opt_doctor?.length + 3, isAdvance: true },
                            ]
                            Doctor_Print_Layout.opt_doctor = [...Doctor_Print_Layout.opt_doctor, ...OBGYNPrintorder];
                        } else {
                            let OBGYNPrintorder = [
                                { is_checked: false, label: 'Medication History', value: 'MedicalHistory', print_order: Doctor_Print_Layout.other_doctor?.length, isAdvance: true },
                                { is_checked: false, label: 'Hospitalization History', value: 'HospitalizationHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 1, isAdvance: true },
                                { is_checked: false, label: 'Social History', value: 'SocialHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 2, isAdvance: true },
                                { is_checked: false, label: 'Family History', value: 'FamilyHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 3, isAdvance: true },
                            ]
                            Doctor_Print_Layout.other_doctor = [...Doctor_Print_Layout.other_doctor, ...OBGYNPrintorder];
                        }
                        this.setState({
                            lockPeriod: response.data.data.doctor_notes_lock_period,
                            transmitSms: response.data.data.late_transmit_summary_sms,
                            summarySms: response.data.data.append_summary_sms,
                            doctorPrintList: response.data.data.doc_notes_print_template ? response.data.data.doc_notes_print_template : Doctor_Print_Layout,
                            dupDocPrintList: JSON.stringify(Doctor_Print_Layout),
                            auto_fetch_prescription_drug: response?.data?.data?.auto_fetch_prescription_drug,
                            drug_search: response.data.data.drug_search ? response.data.data.drug_search : 1,
                            app_landing_sts: response.data.data.app_landing_sts ? response.data.data.app_landing_sts : 'All',
                            doctorStatus: response.data.data.doc_sts_drop_down ? response.data.data.doc_sts_drop_down : [],
                            other_investigation_config: response?.data?.data?.other_investigation_config ? response?.data?.data?.other_investigation_config : OTHER_INVESTIGATION_CONFIG_DATA,
                            complaints_common_textbox: response?.data?.data?.complaints_common_textbox,
                            include_suggestion_in_treat_plan: response?.data?.data?.include_suggestion_in_treat_plan,
                            show_review_plan_time: response?.data?.data?.show_review_plan_time,
                            show_quantity_in_prescription: response?.data?.data?.show_quantity_in_prescription || false,
                            show_allergy_suggestion:response?.data?.data?.show_allergy_suggestion,
                            prescription_save_transmit: response?.data?.data?.prescription_save_transmit || false,
                            show_tablet_unit_in_print: response?.data?.data?.show_tablet_unit_in_print,
                            show_address_field_prescription_print: response?.data?.data?.show_address_field_prescription_print,
                            sort_home_token_by: response?.data?.data?.sort_home_token_by || "default",
                            prescription_language: response?.data?.data?.prescription_language || 'English',
                        })
                    }
                }).catch((error) => {
                    this.setState({
                        doctorPrintList: DOC_PRINT_DEFAULT,
                        dupDocPrintList: JSON.stringify(DOC_PRINT_DEFAULT),
                    })
                    if (error?.response?.data?.message) {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    postDoctorConfigList = () => {
        try {
            let duplicate = false
            let printOrder = false
            if (this.state.loginInfo?.service_type === 'OPT') {
                this.state.doctorPrintList["opt_doctor"]?.forEach((item, i) => {
                    if (!item?.print_order && item?.value !== "FullReport") {
                        printOrder = true
                    }
                    else if (this.state.doctorPrintList["opt_doctor"]?.some((list, index) => (i !== index && list?.print_order === item?.print_order))) {
                        duplicate = true
                    }

                })
            } else {
                this.state.doctorPrintList["other_doctor"]?.forEach((item, i) => {
                    if (!item?.print_order && item?.value !== "FullReport") {
                        printOrder = true
                    }
                    else if (this.state.doctorPrintList["other_doctor"]?.some((list, index) => (i !== index && list?.print_order === item?.print_order))) {
                        duplicate = true
                    }

                })
            }
            if (printOrder) {
                this.errorMessage("Please enter print order")
            }
            else if (duplicate) {
                this.errorMessage("Print order already exists")
            } else {
                let data = {
                    doctor_notes_lock_period: +this.state.lockPeriod,
                    late_transmit_summary_sms: Boolean(this.state.transmitSms),
                    append_summary_sms: Boolean(this.state.summarySms),
                    doc_notes_print_template: this.state.doctorPrintList,
                    auto_fetch_prescription_drug: this.state.auto_fetch_prescription_drug,
                    drug_search: this.state.drug_search ? this.state.drug_search : 1,
                    app_landing_sts: this.state.app_landing_sts ? this.state.app_landing_sts : 'All',
                    other_investigation_config: this.state.other_investigation_config ? this.state.other_investigation_config : OTHER_INVESTIGATION_CONFIG_DATA,
                    complaints_common_textbox: this.state.complaints_common_textbox,
                    include_suggestion_in_treat_plan: this.state.include_suggestion_in_treat_plan,
                    show_review_plan_time: this.state.show_review_plan_time,
                    show_quantity_in_prescription: this.state.show_quantity_in_prescription || false,
                    show_allergy_suggestion:this.state.show_allergy_suggestion,
                    prescription_save_transmit: this.state.prescription_save_transmit,
                    show_tablet_unit_in_print: this.state.show_tablet_unit_in_print,
                    show_address_field_prescription_print: this.state.show_address_field_prescription_print,
                    sort_home_token_by: this.state.sort_home_token_by || "default",
                    prescription_language: this.state.prescription_language || 'English',
                }
                RestAPIService.create(data, Serviceurls.DOC_OPT_CONFIG)
                    .then((response) => {
                        if (response?.data.status === 'success') {
                            this.successMessage(response.data.message)
                            this.getDoctorNotesConfigList()
                            localSetItem('app_landing_sts', this.state.app_landing_sts ? JSON.stringify(this.state.app_landing_sts) : JSON.stringify('All'))
                            localSetItem('drug_search', JSON.stringify(this.state.drug_search))
                            localSetItem('other_investigation_config', JSON.stringify(this.state.other_investigation_config))
                            localSetItem('complaints_common_textbox', JSON.stringify(this.state.complaints_common_textbox))
                            localSetItem('show_quantity_in_prescription', JSON.stringify(this.state.show_quantity_in_prescription))
                            localSetItem('prescription_save_transmit', JSON.stringify(this.state.prescription_save_transmit))
                            localSetItem('show_address_field_prescription', JSON.stringify(this.state.show_address_field_prescription_print))
                            localSetItem('prescription_language',this.state.prescription_language)
                        }
                    }).catch((error) => {
                        if (error?.response?.data?.message) {
                            this.errorMessage(error.response.data.message)
                        } else {
                            this.errorMessage(error.message)
                        }
                    })
            }
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    onChangeHandler = (e, names) => {
        try {
            let value = e.target.value
            switch (names) {
                case 'lockPeriod':
                    if ((CommonValidation.numberOnly(value) && +value <= 90) || value === '') {
                        this.setState({ lockPeriod: value })
                    }
                    break;
                default: break;
            }
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    inputTextBox = (names, value, label, endAdornment, text, width) => {
        try {
            return (
                <TextField
                    size='small'
                    sx={{ width: width }}
                    label={label}
                    autoComplete='off'
                    InputProps={endAdornment ? {
                        endAdornment: <Box component={'div'}><Typography fontWeight={600}>{text}</Typography></Box>
                    } : null}
                    name={names}
                    value={value}
                    onChange={(e) => this.onChangeHandler(e, names)}
                />
            )
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    getLayoutConfiguration = (printList) => {
        try {
            RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_LAYOUT)
                .then((response) => {
                    if (response.data.status === "success") {
                        let {field_data} = response.data.data;
                        if (field_data?.left_data?.length > 0) {
                            field_data?.left_data?.forEach((item) => {
                                printList?.other_doctor?.forEach((list) => {
                                    if (item?.label === list?.label) {
                                        list['label'] = item?.custom_name ? item?.custom_name : item?.label
                                    }
                                })
                                // reset of newly added layouts
                                if (item.is_new) {
                                    printList?.other_doctor.push(
                                        {
                                            is_checked: false,
                                            label: item?.custom_name,
                                            system_name: item?.label,
                                            value: item?.label?.replace(/\s+/g, ''),
                                            print_order: printList?.other_doctor?.length
                                        }
                                    )
                                }
                            })
                            this.setState((prevState) => ({ ...prevState, doctorPrintList: {...printList} }))
                        }
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })

        } catch (e) {
            this.errorMessage(e.message)
        }
    }

    onClearHandler = () => {
        try {
            let Doctor_Print_Layout = JSON.parse(JSON.stringify(DOC_PRINT_DEFAULT))
            if (this.state.loginInfo?.service_type === "ENT") {
                let ENTLayout = { is_checked: true, label: 'Clinical Examination', value: 'ClinicExaminationImage', print_order: Doctor_Print_Layout.other_doctor?.length }
                Doctor_Print_Layout.other_doctor?.push(ENTLayout)
            }
            if (this.state.loginInfo?.service_type === "OBGYN") {
                Doctor_Print_Layout.other_doctor?.push({ is_checked: true, label: 'Obstetric Data', value: 'ObstetricData', print_order: Doctor_Print_Layout.other_doctor?.length })
            }
            if (this.state.specialization === "OBSTETRICS & GYNECOLOGY") {
                let OBGYNPrintorder = [
                    { is_checked: false, label: 'Ovulation', value: 'Ovulation', print_order: Doctor_Print_Layout.other_doctor?.length, isAdvance: true },
                    { is_checked: false, label: 'Antenatal', value: 'Antenatal', print_order: Doctor_Print_Layout.other_doctor?.length + 1, isAdvance: true },
                    { is_checked: false, label: 'Medication History', value: 'MedicalHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 2, isAdvance: true },
                    { is_checked: false, label: 'Hospitalization History', value: 'HospitalizationHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 3, isAdvance: true },
                    { is_checked: false, label: 'Social History', value: 'SocialHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 4, isAdvance: true },
                    { is_checked: false, label: 'Family History', value: 'FamilyHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 5, isAdvance: true },
                    { is_checked: false, label: 'OBGYN History', value: 'OBGYNHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 6, isAdvance: true },
                ]
                Doctor_Print_Layout.other_doctor = [...Doctor_Print_Layout.other_doctor, ...OBGYNPrintorder];
            } else if (this.state.specialization === 'PEDIATRICIAN') {
                let OBGYNPrintorder = [
                    { is_checked: false, label: 'Medication History', value: 'MedicalHistory', print_order: Doctor_Print_Layout.other_doctor?.length, isAdvance: true },
                    { is_checked: false, label: 'Hospitalization History', value: 'HospitalizationHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 1, isAdvance: true },
                    { is_checked: false, label: 'Social History', value: 'SocialHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 2, isAdvance: true },
                    { is_checked: false, label: 'Family History', value: 'FamilyHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 3, isAdvance: true },
                    { is_checked: false, label: 'PD History', value: 'PDHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 4, isAdvance: true },
                    { is_checked: false, label: 'Menstrual History', value: 'MenstrualHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 5, isAdvance: true },
                ]
                Doctor_Print_Layout.other_doctor = [...Doctor_Print_Layout.other_doctor, ...OBGYNPrintorder];
            } else if (this.state.specialization === 'DIABETOLOGY') {
                let OBGYNPrintorder = [
                    { is_checked: false, label: 'Medication History', value: 'MedicalHistory', print_order: Doctor_Print_Layout.other_doctor?.length, isAdvance: true },
                    { is_checked: false, label: 'Hospitalization History', value: 'HospitalizationHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 1, isAdvance: true },
                    { is_checked: false, label: 'Social History', value: 'SocialHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 2, isAdvance: true },
                    { is_checked: false, label: 'Family History', value: 'FamilyHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 3, isAdvance: true },
                    { is_checked: false, label: 'Diabetic History', value: 'DiabeticHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 4, isAdvance: true },
                    { is_checked: true, label: 'Menstrual History', value: 'MenstrualHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 5, isAdvance: true },
                    { is_checked: false, label: 'Nutrition History', value: 'NutritionHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 6, isAdvance: true },
                ]
                Doctor_Print_Layout.other_doctor = [...Doctor_Print_Layout.other_doctor, ...OBGYNPrintorder];
            } else if (this.state.specialization === 'OPHTHALMOLOGY') {
                let OBGYNPrintorder = [
                    { is_checked: false, label: 'Medication History', value: 'MedicalHistory', print_order: Doctor_Print_Layout.opt_doctor?.length, isAdvance: true },
                    { is_checked: false, label: 'Hospitalization History', value: 'HospitalizationHistory', print_order: Doctor_Print_Layout.opt_doctor?.length + 1, isAdvance: true },
                    { is_checked: false, label: 'Social History', value: 'SocialHistory', print_order: Doctor_Print_Layout.opt_doctor?.length + 2, isAdvance: true },
                    { is_checked: false, label: 'Family History', value: 'FamilyHistory', print_order: Doctor_Print_Layout.opt_doctor?.length + 3, isAdvance: true },
                ]
                Doctor_Print_Layout.opt_doctor = [...Doctor_Print_Layout.opt_doctor, ...OBGYNPrintorder];
            } else {
                let OBGYNPrintorder = [
                    { is_checked: false, label: 'Medication History', value: 'MedicalHistory', print_order: Doctor_Print_Layout.other_doctor?.length, isAdvance: true },
                    { is_checked: false, label: 'Hospitalization History', value: 'HospitalizationHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 1, isAdvance: true },
                    { is_checked: false, label: 'Social History', value: 'SocialHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 2, isAdvance: true },
                    { is_checked: false, label: 'Family History', value: 'FamilyHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 3, isAdvance: true },
                    { is_checked: false, label: 'Menstrual History', value: 'MenstrualHistory', print_order: Doctor_Print_Layout.other_doctor?.length + 4, isAdvance: true },
                ]
                Doctor_Print_Layout.other_doctor = [...Doctor_Print_Layout.other_doctor, ...OBGYNPrintorder];
            }
            this.setState({
                lockPeriod: '30',
                transmitSms: false,
                summarySms: false,
                drug_search: 1,
                show_review_plan_time: true,
                other_investigation_config: OTHER_INVESTIGATION_CONFIG_DATA,
                sort_home_token_by: "default",
                ...(this.state.loginInfo?.service_type === "OPT" && { doctorPrintList: Doctor_Print_Layout }),
                prescription_language: 'English',
            }, () => {
                if (this.state.loginInfo?.service_type !== 'OPT') {
                    this.getLayoutConfiguration(Doctor_Print_Layout)
                }
            })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    onChangeCheckBox = (e, index, key) => {
        try {
            let value = e.target.checked
            if (this.state.loginInfo?.service_type === 'OPT') {
                if (this.state.doctorPrintList['opt_doctor'][index]['label'] === 'Full Report') {
                    this.state.doctorPrintList['opt_doctor'][index]['is_checked'] = value
                    this.setState({ doctorPrintList: this.state.doctorPrintList }, () => {
                        if (this.state.doctorPrintList['opt_doctor'][index]['label'] === 'Full Report' && this.state.doctorPrintList['opt_doctor'][index]['is_checked']) {
                            this.state.doctorPrintList?.opt_doctor?.forEach(element => element.is_checked = true)
                            this.setState({ doctorPrintList: this.state.doctorPrintList })
                        } else {
                            this.state.doctorPrintList?.opt_doctor?.forEach(element => element.is_checked = false)
                            this.setState({ doctorPrintList: this.state.doctorPrintList })
                        }
                    })
                } else {
                    this.state.doctorPrintList['opt_doctor'][index]['is_checked'] = value
                    this.setState({ doctorPrintList: this.state.doctorPrintList }, () => {
                        let filterArray = this.state.doctorPrintList?.opt_doctor?.filter(item => item?.label !== 'Full Report')
                        let checkAll = filterArray?.every(item => item.is_checked)
                        this.state.doctorPrintList?.opt_doctor?.forEach(element => {
                            if (element.label === 'Full Report' && checkAll) {
                                element.is_checked = true
                            } else if (!checkAll && element.label === 'Full Report') {
                                element.is_checked = false
                            }
                        })
                        this.setState({ doctorPrintList: this.state.doctorPrintList })
                    })
                }

            } else {
                if (this.state.doctorPrintList['other_doctor'][index]['label'] === 'Full Report') {
                    this.state.doctorPrintList['other_doctor'][index]['is_checked'] = value
                    this.setState({ doctorPrintList: this.state.doctorPrintList }, () => {
                        if (this.state.doctorPrintList['other_doctor'][index]['label'] === 'Full Report' && this.state.doctorPrintList['other_doctor'][index]['is_checked']) {
                            this.state.doctorPrintList?.other_doctor?.forEach(element => element.is_checked = true)
                            this.setState({ doctorPrintList: this.state.doctorPrintList })
                        } else {
                            this.state.doctorPrintList?.other_doctor?.forEach(element => element.is_checked = false)
                            this.setState({ doctorPrintList: this.state.doctorPrintList })
                        }
                    })
                } else {
                    this.state.doctorPrintList['other_doctor'][index]['is_checked'] = value
                    this.setState({ doctorPrintList: this.state.doctorPrintList }, () => {
                        let filterArray = this.state.doctorPrintList?.other_doctor?.filter(item => item?.label !== 'Full Report')
                        let checkAll = filterArray?.every(item => item.is_checked)
                        this.state.doctorPrintList?.other_doctor?.forEach(element => {
                            if (element.label === 'Full Report' && checkAll) {
                                element.is_checked = true
                            } else if (!checkAll && element.label === 'Full Report') {
                                element.is_checked = false
                            }
                        })
                        this.setState({ doctorPrintList: this.state.doctorPrintList })
                    })
                }
            }
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    checkData = () => {
        try {
            let message = null;
            if (this.state.loginInfo?.service_type === 'OPT') {
                let check = this.state.doctorPrintList?.opt_doctor?.some(item => item?.is_checked)
                if (!check) {
                    message = 'Please Select atleast one for print'
                }
            } else {
                let check = this.state.doctorPrintList?.other_doctor?.some(item => item?.is_checked)
                if (!check) {
                    message = 'Please Select atleast one for print'
                }
            }
            return message;
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    renderCheckbox = (key) => {
        try {
            return (
                <Checkbox
                    onClick={(event) => {
                        this.setState({ [key]: event.target.checked })
                    }}
                    checked={this.state[key] || false} />
            )
        }
        catch (e) {
            this.errorMessage(e.message)
        }
    }

    handleOtherInvestCheckBox = (e, key) => {
        try {
            let checked = e.target.checked
            let otherIvesData = { ...this.state.other_investigation_config }
            otherIvesData[key] = { ...otherIvesData[key], is_checked: checked }
            this.setState({ other_investigation_config: otherIvesData })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    render() {
        let loginInfo = JSON.parse(localGetItem('loggedInUserInfo'))
        const isUmaNote = loginInfo?.new_doctor_notes_template;
        return (
            <Box component={"div"} className='eMed_refdoc_container' style={{ backgroundColor: "white" }} p={'0.5vw'}>
                <Box component={'div'} border={'1px solid lightgray'} borderRadius={'10px'} height={'68vh'}>
                    <Box component={'div'} height={'3vw'} borderBottom={'1px solid lightgray'} display={'flex'} alignItems={'center'} pl={'0.5vw'}>
                        <Typography fontWeight={'600'}>Doctor Notes Configuration</Typography>
                    </Box>
                    <Box component={'div'} height={'60vh'} overflow={'auto'} p={'0.5vw'}>
                        <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} style={{ padding: "0.5vw" }}>
                            <Box component={'div'}>
                                <Typography>Duration for Doctor Notes Lock Period ?</Typography>
                            </Box>
                            <Box component={'div'} display={'flex'} flexDirection={'column'} alignItems={'flex-end'}>
                                {this.inputTextBox('lockPeriod', this.state.lockPeriod, '', true, 'Days', '10vw')}
                                <Typography mt={"0.25vw"} fontSize={'0.8vw'} color={'gray'}>*3 days is the default lock period</Typography>
                            </Box>
                        </Box>
                        <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} mt={'.5vw'} style={{ padding: "0.5vw" }}>
                            <Box component={'div'}>
                                <Typography>{this.state.isOPT ? 'Medication Search Based On' : 'Prescription Search Based On'}</Typography>
                            </Box>
                            <Box component={'div'} display={'flex'} flexDirection={'column'} alignItems={'flex-end'}>
                                <Select
                                    size='small'
                                    value={this.state.drug_search}
                                    onChange={(e) => this.setState({ drug_search: e.target.value })}
                                    sx={{ width: '10vw' }}
                                >
                                    {SEARCH_DRUG_NAME?.map((item, index) => {
                                        return (
                                            <MenuItem key={index} value={item?.value}>{item?.label}</MenuItem>
                                        )
                                    })}
                                </Select>
                            </Box>
                        </Box>
                        <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} mt={'.5vw'} style={{ padding: "0.5vw" }}>
                            <Box component={'div'}>
                                <Typography>Prescription - Auto-fetch Previous Drugs</Typography>
                            </Box>
                            <Box component={'div'} display={'flex'} flexDirection={'column'} alignItems={'flex-end'}>
                                {this.renderCheckbox("auto_fetch_prescription_drug")}
                            </Box>
                        </Box>
                        <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} mt={'.5vw'} style={{ padding: "0.5vw" }}>
                            <Box component={'div'}>
                                <Typography>Home Screen Landing Based On</Typography>
                            </Box>
                            <Box component={'div'} display={'flex'} flexDirection={'column'} alignItems={'flex-end'}>
                                <Select
                                    size='small'
                                    value={this.state.app_landing_sts}
                                    onChange={(e) => this.setState({ app_landing_sts: e.target.value })}
                                    sx={{ width: '10vw' }}
                                >
                                    {this.state.doctorStatus?.map((item, index) => {
                                        return (
                                            <MenuItem key={index} value={item}>{item}</MenuItem>
                                        )
                                    })}
                                </Select>
                            </Box>
                        </Box>
                        <Box component={'div'} mt={'.5vw'}>
                            <Accordion elevation={1}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Box component={'div'} display={'flex'} alignItems={'center'} justifyContent={'space-between'} width={"100%"}>
                                        <Typography fontSize={'0.9vw'} fontWeight={600}>Select default option for Print</Typography>
                                    </Box>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Box component={'div'} display={'flex'} flexWrap={'wrap'} flexDirection={"row"} marginLeft={"2vw"}>
                                        <Box component={'div'} display={'flex'} flexWrap={'wrap'} flexDirection={"column"}>
                                            <Typography sx={{ fontWeight: 600, mb: "1vw" }}>{"Notes"}</Typography>
                                            {this.state.loginInfo?.service_type === 'OPT' ?
                                                this.state.doctorPrintList?.opt_doctor?.map((item, index) => {
                                                    if (!item["isAdvance"]) {
                                                        return (
                                                            <Box component={'div'} key={index} width={'15vw'} height={'6vh'} mb={"0.5vh"}>
                                                                <FormControlLabel checked={item.is_checked} onChange={(e) => this.onChangeCheckBox(e, index, item?.label)} control={<Checkbox size='small' />} label={item.label === 'Full Report' ? <Typography fontWeight={600}>{item?.label}</Typography> : item?.label} />
                                                            </Box>
                                                        )
                                                    }
                                                }) :

                                                this.state.doctorPrintList?.other_doctor?.map((item, index) => {
                                                    if (!item["isAdvance"]) {
                                                        return (
                                                            <Box component={'div'} key={index} height={'6vh'} mb={"0.5vh"}>
                                                                <FormControlLabel checked={item.is_checked} onChange={(e) => this.onChangeCheckBox(e, index, item?.label)} control={<Checkbox size='small' />} label={item.label === 'Full Report' ? <Typography fontWeight={600}>{item?.label}</Typography> : item?.label} />
                                                            </Box>
                                                        )
                                                    }
                                                })
                                            }
                                        </Box>
                                        <Box component={'div'} display={'flex'} flexWrap={'wrap'} flexDirection={"column"} marginLeft={"4vw"}>
                                            <Box component={'div'} display={'flex'} flexWrap={'wrap'} flexDirection={"column"} marginLeft={"4vw"}>
                                                <Typography sx={{ fontWeight: 600, mb: "1vw" }}>{"Print Order"}</Typography>
                                                {this.state.loginInfo?.service_type === 'OPT' ?
                                                    this.state.doctorPrintList?.opt_doctor?.map((item, index) => {
                                                        if (!item["isAdvance"]) {
                                                            return (
                                                                <Box component={'div'} key={index} width={'10vw'} height={'6vh'} sx={{ mb: "0.5vh" }}>
                                                                    {item.label === 'Full Report' ? null
                                                                        : <TextField
                                                                            inputProps={{ maxLength: this.state.doctorPrintList?.opt_doctor?.length }}
                                                                            size='small'
                                                                            autoComplete='off'
                                                                            sx={{ width: "8vw", height: "5vh", mt: "-0.2vh", mb: "0.8vh" }}
                                                                            label="Print Order*"
                                                                            value={item?.print_order || ""}
                                                                            onChange={(e) => {
                                                                                let number = CommonValidation.numberOnly(e.target.value);
                                                                                if ((number && e.target.value <= this.state.doctorPrintList?.opt_doctor?.length - 1) || e.target.value === "") {
                                                                                    item["print_order"] = +e.target.value
                                                                                    this.setState({ doctorPrintList: this.state.doctorPrintList })
                                                                                }
                                                                            }}
                                                                        />
                                                                    }
                                                                </Box>
                                                            )
                                                        }
                                                    }) :
                                                    this.state.doctorPrintList?.other_doctor?.map((item, index) => {
                                                        if (!item["isAdvance"]) {
                                                            return (
                                                                <Box component={'div'} key={index} width={'10vw'} height={'6vh'} sx={{ mb: "0.5vh" }}>
                                                                    {item.label === 'Full Report' ? null
                                                                        :
                                                                        <TextField
                                                                            inputProps={{ maxLength: this.state.doctorPrintList?.other_doctor?.length }}
                                                                            size="small"
                                                                            autoComplete="off"
                                                                            sx={{ width: "8vw", height: "5vh", mt: "-0.2vh", mb: "0.8vh" }}
                                                                            label="Print Order*"
                                                                            value={item?.print_order || ""}
                                                                            onChange={(e) => {
                                                                                let number = CommonValidation.numberOnly(e.target.value);
                                                                                if ((number && e.target.value <= this.state.doctorPrintList?.other_doctor?.length - 1) || e.target.value === "") {
                                                                                    item["print_order"] = +e.target.value
                                                                                    this.setState({ doctorPrintList: this.state.doctorPrintList })
                                                                                }
                                                                            }}
                                                                        />
                                                                    }
                                                                </Box>
                                                            )
                                                        }
                                                    })
                                                }
                                            </Box>
                                        </Box>
                                    </Box>


                                    {this.state.loginInfo?.service_type === 'OPT' ? <Box>
                                        <Box sx={{ margin: "2vh" }}>
                                            <Typography sx={{ fontWeight: 600 }}>{"Advanced Options"}</Typography>
                                        </Box>
                                        <Box display={"flex"} flexDirection={"row"} marginLeft={"2vw"}>
                                            <Box display={"flex"} flexDirection={"column"}>
                                                {
                                                    this.state.doctorPrintList?.opt_doctor?.map((item, index) => {
                                                        if (item["isAdvance"] === true) {
                                                            return (
                                                                <Box component={'div'} key={index} width={'15vw'} height={'6vh'} mb={"0.5vh"}>
                                                                    <FormControlLabel checked={item.is_checked} onChange={(e) => this.onChangeCheckBox(e, index, item?.label)} control={<Checkbox size='small' />} label={item.label === 'Full Report' ? <Typography fontWeight={600}>{item?.label}</Typography> : item?.label} />
                                                                </Box>
                                                            )
                                                        }
                                                    })
                                                }
                                            </Box>
                                            <Box display={"flex"} flexDirection={"column"} marginLeft={"4vw"}>
                                                {
                                                    this.state.doctorPrintList?.opt_doctor?.map((item, index) => {
                                                        if (item["isAdvance"] === true) {
                                                            return (
                                                                <Box component={'div'} key={index} width={'10vw'} height={'6vh'} sx={{ mb: "0.5vh" }} marginLeft={"4vw"}>
                                                                    {item.label === 'Full Report' ? null
                                                                        : <TextField
                                                                            size="small"
                                                                            autoComplete="off"
                                                                            sx={{ width: "8vw", height: "5vh", mt: "-0.2vh", mb: "0.8vh" }}
                                                                            label="Print Order*"
                                                                            value={item?.print_order || ""}
                                                                            onChange={(e) => {
                                                                                let number = CommonValidation.numberOnly(e.target.value);
                                                                                if ((number && e.target.value <= (this.state.doctorPrintList?.opt_doctor?.length - 1)) || e.target.value === "") {
                                                                                    item["print_order"] = +e.target.value
                                                                                    this.setState({ doctorPrintList: this.state.doctorPrintList })
                                                                                }
                                                                            }}
                                                                        />
                                                                    }

                                                                </Box>
                                                            )
                                                        }
                                                    })
                                                }
                                            </Box>
                                        </Box>
                                    </Box> :
                                        this.state.doctorPrintList?.other_doctor?.some((item) => item["isAdvance"] === true) ? <Box>
                                            <Box sx={{ margin: "2vh" }}>
                                                <Typography sx={{ fontWeight: 600 }}>{"Advanced Options"}</Typography>
                                            </Box>
                                            <Box display={"flex"} flexDirection={"row"} marginLeft={"2vw"}>
                                                <Box display={"flex"} flexDirection={"column"}>
                                                    {
                                                        this.state.doctorPrintList?.other_doctor?.map((item, index) => {
                                                            if (item["isAdvance"] === true) {
                                                                return (
                                                                    <Box component={'div'} key={index} height={'6vh'} mb={"0.5vh"}>
                                                                        <FormControlLabel checked={item.is_checked} onChange={(e) => this.onChangeCheckBox(e, index, item?.label)} control={<Checkbox size='small' />} label={item.label === 'Full Report' ? <Typography fontWeight={600}>{item?.label}</Typography> : item?.label} />
                                                                    </Box>
                                                                )
                                                            }
                                                        })
                                                    }
                                                </Box>
                                                <Box display={"flex"} flexDirection={"column"} marginLeft={"4vw"}>
                                                    {
                                                        this.state.doctorPrintList?.other_doctor?.map((item, index) => {
                                                            if (item["isAdvance"] === true) {
                                                                return (
                                                                    <Box component={'div'} key={index} width={'10vw'} height={'6vh'} sx={{ mb: "0.5vh" }} marginLeft={"4vw"}>
                                                                        {item.label === 'Full Report' ? null
                                                                            : <TextField
                                                                                size="small"
                                                                                autoComplete="off"
                                                                                sx={{ width: "8vw", height: "5vh", mt: "-0.2vh", mb: "0.8vh" }}
                                                                                label="Print Order*"
                                                                                value={item?.print_order || ""}
                                                                                onChange={(e) => {
                                                                                    let number = CommonValidation.numberOnly(e.target.value);
                                                                                    if ((number && e.target.value <= (this.state.doctorPrintList?.other_doctor?.length - 1)) || e.target.value === "") {
                                                                                        item["print_order"] = +e.target.value
                                                                                        this.setState({ doctorPrintList: this.state.doctorPrintList })
                                                                                    }
                                                                                }}
                                                                            />
                                                                        }

                                                                    </Box>
                                                                )
                                                            }
                                                        })
                                                    }
                                                </Box>
                                            </Box>
                                        </Box> : null}
                                </AccordionDetails>
                            </Accordion>
                        </Box>
                        {this.state.loginInfo?.service_type !== 'OPT' &&
                            <>
                                <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} mt={'.5vw'} style={{ padding: "0.5vw" }}>
                                    <Box component={'div'}>
                                        <Typography>Complaints - Show individual comments in a single comment box</Typography>
                                    </Box>
                                    <Box component={'div'} display={'flex'} flexDirection={'column'} alignItems={'flex-end'}>
                                        {this.renderCheckbox("complaints_common_textbox")}
                                    </Box>
                                </Box>
                                <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} mt={'.5vw'} style={{ padding: "0.5vw" }}>
                                    <Box component={'div'}>
                                        <Typography>Show Quantity in Prescription and Doctor Visit Report</Typography>
                                    </Box>
                                    <Box component={'div'} display={'flex'} flexDirection={'column'} alignItems={'flex-end'}>
                                        {this.renderCheckbox("show_quantity_in_prescription")}
                                    </Box>
                                </Box>
                            </>}
                        {this.state.loginInfo?.service_type !== 'OPT' ?
                            <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} mt={'.5vw'} style={{ padding: "0.5vw" }}>
                                <Box component={'div'}>
                                    <Typography>Include Surgery Suggestion in Treatment Plan - Procedure</Typography>
                                </Box>
                                <Box component={'div'} display={'flex'} flexDirection={'column'} alignItems={'flex-end'}>
                                    {this.renderCheckbox("include_suggestion_in_treat_plan")}
                                </Box>
                            </Box> : null}
                        <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} mt={'.5vw'} style={{ padding: "0.5vw" }}>
                            <Box component={'div'}>
                                <Typography>Show Review Plan Time in the DVR Print</Typography>
                            </Box>
                            <Box component={'div'} display={'flex'} flexDirection={'column'} alignItems={'flex-end'}>
                                {this.renderCheckbox("show_review_plan_time")}
                            </Box>
                        </Box>
                        {this.state.loginInfo?.service_type === 'OPT' ?
                            <Box component={'div'} mt={'0.5vw'}>
                                <Accordion elevation={1}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Box component={'div'} display={'flex'} alignItems={'center'} justifyContent={'space-between'} width={"100%"}>
                                            <Typography fontSize={'0.9vw'} fontWeight={600}>Select default option for Other Investigation</Typography>
                                        </Box>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Box component={'div'} display={'flex'} flexWrap={'wrap'} flexDirection={"row"} marginLeft={"2vw"}>
                                            {Object.keys(this.state.other_investigation_config)?.map((key, index) => {
                                                return (
                                                    <Box component={'div'} key={index} width={'15vw'} height={'6vh'} mb={"0.5vh"}
                                                    >
                                                        <FormControlLabel
                                                            checked={this.state.other_investigation_config[key]?.is_checked}
                                                            onChange={(e) => this.handleOtherInvestCheckBox(e, key)}
                                                            control={<Checkbox size='small' />}
                                                            label={<Typography fontWeight={600}>{key}</Typography>}
                                                        />
                                                    </Box>
                                                )
                                            })}
                                        </Box>
                                    </AccordionDetails>
                                </Accordion>
                            </Box> : null}
                        {/* <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} style={{ paddingLeft: "0.5vw", marginBottom: "0.5vw" }}>
                            <Box component={'div'}>
                                <Typography>Late Transmit Summary SMS</Typography>
                            </Box>
                            <Box component={'div'} display={'flex'} flexDirection={'column'} alignItems={'center'}>
                                <RadioGroup
                                    row
                                    value={this.state.transmitSms}
                                    onChange={(e) => {
                                        let value = e.target.value
                                        this.setState({ transmitSms: value })
                                    }}
                                >
                                    <FormControlLabel value={true} control={<Radio size='small' />} label="Yes" />
                                    <FormControlLabel value={false} control={<Radio size='small' />} label="No" />
                                </RadioGroup>
                            </Box>
                        </Box> */}

                        {/* <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} style={{ paddingLeft: "0.5vw", marginTop: "0.5vw" }}>
                            <Box component={'div'}>
                                <Typography>Append Summary SMS</Typography>
                            </Box>
                            <Box component={'div'} display={'flex'} flexDirection={'column'} alignItems={'center'}>
                                <RadioGroup
                                    value={this.state.summarySms}
                                    row
                                    onChange={(e) => {
                                        let value = e.target.value
                                        this.setState({ summarySms: value })
                                    }}
                                >
                                    <FormControlLabel value={true} control={<Radio size='small' />} label="Yes" />
                                    <FormControlLabel value={false} control={<Radio size='small' />} label="No" />
                                </RadioGroup>
                            </Box>
                        </Box> */}
                        <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} mt={'.5vw'} style={{ padding: "0.5vw" }}>
                            <Box component={'div'}>
                                <Typography>Show Generic Name Suggestion In Allergy</Typography>
                            </Box>
                            <Box component={'div'} display={'flex'} flexDirection={'column'} alignItems={'flex-end'}>
                                {this.renderCheckbox("show_allergy_suggestion")}
                            </Box>
                        </Box>
                        <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} mt={'.5vw'} style={{ padding: "0.5vw" }}>
                            <Box component={'div'}>
                                <Typography>Enable Single-Click Save And Transmit For Prescription</Typography>
                            </Box>
                            <Box component={'div'} display={'flex'} flexDirection={'column'} alignItems={'flex-end'}>
                                {this.renderCheckbox("prescription_save_transmit")}
                            </Box>
                        </Box>
                        { this.state.loginInfo?.service_type !== "OPT" ? <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} mt={'.5vw'} style={{ padding: "0.5vw" }}>
                            <Box component={'div'}>
                                <Typography>Show Tablet in Prescription Print</Typography>
                            </Box>
                            <Box component={'div'} display={'flex'} flexDirection={'column'} alignItems={'flex-end'}>
                                {this.renderCheckbox("show_tablet_unit_in_print")}
                            </Box>
                        </Box>
                        : null }
                          <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} mt={'.5vw'} style={{ padding: "0.5vw" }}>
                            <Box component={'div'}>
                                <Typography>Show Patient Address in Prescription Print</Typography>
                            </Box>
                            <Box component={'div'} display={'flex'} flexDirection={'column'} alignItems={'flex-end'}>
                                {this.renderCheckbox("show_address_field_prescription_print")}
                            </Box>
                        </Box>
                        <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} mt={'.5vw'} style={{ padding: "0.5vw" }}>
                            <Box component={'div'}>
                                <Typography>Sort Home by Token Number (Default / Ascending / Descending)</Typography>
                            </Box>
                            <Box component={'div'} display={'flex'} flexDirection={'column'} alignItems={'flex-end'}>
                                <RadioGroup
                                    value={this.state.sort_home_token_by}
                                    sx={{ display: 'flex', flexDirection: 'row' }}
                                    onChange={(e) => {
                                        this.setState({ sort_home_token_by: e.target.value })
                                    }}
                                >
                                    <FormControlLabel value={'default'} control={<Radio size='small' />} label="Default" />
                                    <FormControlLabel value={'asc'} control={<Radio size='small' />} label="Ascending" />
                                    <FormControlLabel value={'desc'} control={<Radio size='small' />} label="Descending" />
                                </RadioGroup>
                            </Box>
                        </Box>
                        {!isUmaNote ? <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} mt={'.5vw'} style={{ padding: "0.5vw" }}>
                            <Box component={'div'}>
                                <Typography>{`Default ${this.state.loginInfo?.service_type === 'OPT' ? 'Medication' : 'Prescription'} Language`}</Typography>
                            </Box>
                            <Box component={'div'} display={'flex'} flexDirection={'column'} alignItems={'flex-end'}>
                                <Select
                                    size='small'
                                    value={this.state.prescription_language}
                                    onChange={(e) => this.setState({ prescription_language: e.target.value })}
                                    sx={{ width: '10vw' }}
                                >
                                    {PRESCRIPTION_LANGUAGE?.map((item, index) => {
                                        return (
                                            <MenuItem key={index} value={item?.value}>{item?.label}</MenuItem>
                                        )
                                    })}
                                </Select>
                            </Box>
                        </Box> : null}
                    </Box>
                </Box>
                <Box component={'div'} height={'3vw'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                    <Button
                        sx={{ height: '2vw', mr: '1vw', textTransform: 'capitalize' }}
                        variant='outlined'
                        onClick={() => this.onClearHandler()}
                    >Reset</Button>
                    <Button
                        sx={{ height: '2vw', mr: '1vw', textTransform: 'capitalize' }}
                        variant='contained'
                        onClick={() => {
                            let checkValues = this.checkData()
                            if (checkValues === null) {
                                this.postDoctorConfigList()
                            } else {
                                this.errorMessage(checkValues)
                            }
                        }}
                    >Save</Button>
                </Box>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
            </Box>
        )
    }
}